// react-router-dom
import { useRoutes } from 'react-router-dom';

// routes
import StudioRoutes from './StudioRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import UserRoutes from './UserRoutes';
import OnboardingRoutes from './OnboardingRoutes';
import PublicRoutes from './PublicRoutes';
import TripGuideRoutes from './TripGuideRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  // public routes
  const routes = [StudioRoutes, PublicRoutes, AuthenticationRoutes, OnboardingRoutes, UserRoutes, TripGuideRoutes];

  return useRoutes(routes);
}
